module.exports = __webpack_public_path__ + "static/img/image-acoustic-pack@2x.812b6fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/expansion/image-acoustic-pack@2x.png
// module id = wFlJ
// module chunks = 13